/* eslint-disable no-unused-vars */

export default function () {
  // '_this' must be created as a reference to Vue component instance 'this', otherwise it will be 'null'
  const _this = this;
  return {
    inputHandler({ prop, data }) {
      _this.data.newProfile[prop] = data;
      _this.checkRequiredFiled();
    },
    checkRequiredFiled: _this.checkRequiredFiled,
    isAllRequirementPasses: _this.isAllRequirementPasses
  }
}
